import React from "react";
import { DropZoneProvider } from "../contexts/drop-zone-context";
import ImportZones from "./ImportZones";

export default ({ id }) => {
  return (
    <DropZoneProvider>
      <ImportZones id={id} />
    </DropZoneProvider>
  );
};
